import React from "react";
import  Shape124  from './../shapes/Kidney-shape.svg';

export const Accordion = ({ title, image, children }) => {
    const [isOpen, setOpen] = React.useState(false);
    return (
      <div className="accordion-wrapper">
        
        <div
          className={`accordion-title ${isOpen ? "open" : ""}`}
          onClick={() => setOpen(!isOpen)}
          >
          {title}
          {
            image ? <img src={image} alt="" className="parent-img" /> : ''
          }
        </div>
        <div className={`accordion-item ${!isOpen ? "collapsed" : ""}`}>
          <div className="accordion-content">{children}</div>
        </div>
      </div>
    );
};